import { Trans } from 'react-i18next';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import StyledHeading from '/shared/styled/components/StyledHeading';
export default function IntroStep1() {
  return (
    <>
      <StyledHeading $green as="h2" $type="h2" $bold>
        {/* @i18n: Calculate your airport's emissions */}
        <Trans i18nKey="business:GettingStartedPage.step1.heading" />
      </StyledHeading>
      <StyledParagraph>
        {/* @i18n: Calculate the carbon emissions of the locations you want to include in this carbon[...] */}
        <Trans i18nKey="business:GettingStartedPage.step1.para1" />
      </StyledParagraph>
      <StyledParagraph>
        {/* @i18n: If you include multiple locations, you will need to aggregate the data before entering[...] */}
        <Trans i18nKey="business:GettingStartedPage.step1.para2" />
      </StyledParagraph>
      <StyledParagraph>
        {/* @i18n: Carbon emissions refer to a release of carbon to the atmosphere associated with your[...] */}
        <Trans i18nKey="business:GettingStartedPage.step1.para3" />
      </StyledParagraph>
      <StyledParagraph>
        {/* @i18n: To understand your emissions, you will need to calculate your scope 1, 2 and 3 emissions: */}
        <Trans i18nKey="business:GettingStartedPage.step1.para3b" />
      </StyledParagraph>
      <StyledHeading $bold as="h3" $type="h6">
        {/* @i18n: Scope 1 */}
        <Trans i18nKey="business:GettingStartedPage.scopes.scope1.title" />
      </StyledHeading>
      <StyledParagraph>
        <Trans
          i18nKey="business:GettingStartedPage.scopes.scope1.para"
          components={{
            1: <b />,
          }}
        />
      </StyledParagraph>
      <StyledHeading $bold as="h3" $type="h6">
        {/* @i18n: Scope 2 */}
        <Trans i18nKey="business:GettingStartedPage.scopes.scope2.title" />
      </StyledHeading>
      <StyledParagraph>
        <Trans
          i18nKey="business:GettingStartedPage.scopes.scope2.para"
          components={{
            1: <b />,
          }}
        />
      </StyledParagraph>
      <StyledHeading $bold as="h3" $type="h6">
        {/* @i18n: Scope 3* */}
        <Trans i18nKey="business:GettingStartedPage.scopes.scope3.title" />
      </StyledHeading>
      <StyledParagraph>
        {/* @i18n: These are all other indirect carbon emissions that occur in the airport's value chain[...] */}
        <Trans
          i18nKey="business:GettingStartedPage.scopes.scope3.para1"
          components={{
            1: <b />,
          }}
        />
      </StyledParagraph>
      <StyledParagraph>
        <Trans i18nKey="business:GettingStartedPage.scopes.scope3.para2" />
      </StyledParagraph>
      <StyledParagraph>
        <Trans i18nKey="business:GettingStartedPage.scopes.scope3.para3" />
      </StyledParagraph>
    </>
  );
}
